import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from '../../../graphql/GraphQlProvider';
import { GroupBooking } from '../../../graphql/groups.datatypes';
import { gqlGroupBooking } from '../getGroupBooking.api';

interface DeleteGroupBookingInput {
  id: number
}

interface DeleteGroupBookingData {
  deleteGroupBooking: GroupBooking
}

export const DELETE_GRUOP_MUTATION = gql`
    mutation deleteGroupBooking($id: Int!) {
        deleteGroupBooking(id: $id) {
            ${gqlGroupBooking}
        }
    }
`;

export const deleteGroupBooking = () => useMutation<DeleteGroupBookingData, DeleteGroupBookingInput>(
  DELETE_GRUOP_MUTATION,
  {
    update: updateCacheByType('GroupBooking'),
  }
);

export default deleteGroupBooking;